import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';

export const CurrentItemTitle = styled.h1`
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 500;

  @media (min-width: ${Breakpoints.tablet}px) {
    font-size: 20px;
    margin-bottom: 0;
  }

  @media (hover: hover) {
    a {
      &:hover {
        color: ${({ theme }) => theme.colors.systemColors.blue};
      }
    }
  }
`;
